// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"80":"385568817e5e12cf8941","94":"f62d7ebc459447207f7e","254":"04348904f4c592bc20cf"}[chunkId] + ".js";
};